import { render, staticRenderFns } from "./DashboardGuideDialog.vue?vue&type=template&id=79eb75a8&scoped=true"
import script from "./DashboardGuideDialog.vue?vue&type=script&lang=js"
export * from "./DashboardGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardGuideDialog.vue?vue&type=style&index=0&id=79eb75a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb75a8",
  null
  
)

export default component.exports